<template>
  <ListTask :hasFilterMatter="true"/>
</template>

<script>

import ListTask from '@/views/tasks/TaskList'
// this.$refs.task.query.query = [{ field: 'matter__id',value: matter_id , condition: '=' }]


export default {
  name:"listMatterTask",
  components:{
    ListTask
  }
};
</script>

<style>
@import "../style/style.css";
.vs-tabs--ul,.vs-tabs-primary .con-ul-tabs .line-vs-tabs{
  box-shadow: none !important;
}
[dir] .ant-input{
  border-radius: 3px !important;
}
[dir=ltr] .ant-modal-footer{
  display: none !important;
}
.task .ant-modal{
  top: 10px !important;
}
.ant-tag{
  border-radius: 3px !important;
}
</style>


